import React from 'react';
import { Box, Typography } from '@mui/material';
import i18next from 'i18next';
import styles from './webshop-banner.module.scss';
import images from '../../../../assets/img';

const WebshopBanner = () => {
  return (
    <Box className={styles['banner-container']}>
      <Box
        component='img'
        src={images.webshopBanner}
        className={styles['banner']}
        alt={i18next.t('SOLUTIONS.EXPLORE_SOLUTIONS')}
      />
      <Box className={styles['card']} sx={{ backgroundColor: 'common.light' }}>
        <Typography
          component='p'
          variant='mainHeading'
          mb={2}
          className={styles['heading']}
        >
          {i18next.t('SOLUTIONS.EXPLORE_SOLUTIONS')}
        </Typography>
        <Typography
          component='p'
          variant='mediumText'
          className={styles['description']}
        >
          {i18next.t('SOLUTIONS.BANNER_DESCRIPTION')}
        </Typography>
      </Box>
    </Box>
  );
};
export default WebshopBanner;
